(() => {
  'use strict';
  const rendererFor = productId => productId === '10380779421915'
    ? window.LDSGrillePreview
    : productId === '10380889784539'
      ? window.LDSAudiGrillePreview
      : window.LDSMercedesGrillePreview;

  const boot = () => document.querySelectorAll('[data-lds-grille-showcase]').forEach(root => {
    if (root.dataset.grilleShowcaseReady === 'true') return;
    root.dataset.grilleShowcaseReady = 'true';
    const image = root.querySelector('[data-grille-showcase-image]');
    const canvas = root.querySelector('[data-grille-showcase-canvas]');
    const productId = root.dataset.productId;
    const previewConfigNode = root.querySelector('[data-grille-showcase-preview-config]');
    let previewConfig = null;
    try { previewConfig = previewConfigNode ? JSON.parse(previewConfigNode.textContent || 'null') : null; } catch (_error) { previewConfig = null; }
    const price = root.querySelector('[data-grille-showcase-price]');
    const cta = root.querySelector('[data-grille-showcase-cta]');
    const buttons = [...root.querySelectorAll('[data-grille-showcase-mode]')];
    let controller = null;
    let mountAttempts = 0;
    const sourceUrl = image?.currentSrc || image?.getAttribute('src') || image?.src || '';
    const mountPreview = () => {
      if (controller || !image || !canvas) return;
      const renderer = rendererFor(productId);
      if (!renderer?.mount) {
        if (productId) {
          mountAttempts += 1;
          if (mountAttempts < 40) window.setTimeout(mountPreview, 50);
        }
        return;
      }
      try {
        controller = renderer.mount({image, canvas, sourceUrl, productId, previewConfig});
        if (controller) {
          root.dataset.grilleShowcaseMaskScope = 'hero-only';
          const selected = buttons.find(button => button.classList.contains('is-selected')) || buttons[0];
          if (selected?.dataset.grilleShowcaseMode) applyMode(selected);
        }
      } catch (_error) {
        root.dataset.grilleShowcaseMaskHold = 'MASK_RENDERER_MOUNT_FAILED';
      }
    };
    const update = button => {
      buttons.forEach(node => {
        const selected = node === button;
        node.classList.toggle('is-selected', selected);
        node.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
      const mode = button.dataset.grilleShowcaseMode || '';
      if (price && button.dataset.grilleShowcasePrice) price.textContent = button.dataset.grilleShowcaseMoney || `$${button.dataset.grilleShowcasePrice}`;
      if (controller?.setMode) controller.setMode(productId === '10380779421915' ? (mode === 'FLOW' ? 'flow' : 'standard') : mode.toLowerCase());
      if (cta && button.dataset.grilleShowcaseVariant) {
        const url = new URL(root.dataset.previewUrl, location.origin);
        url.searchParams.set('variant', button.dataset.grilleShowcaseVariant);
        cta.href = url.toString();
      }
    };
    const applyMode = button => update(button);
    buttons.forEach(button => button.addEventListener('click', () => applyMode(button)));
    if (buttons[0]) applyMode(buttons[0]);
    root.__ldsGrilleShowcase = {getController: () => controller};
    mountPreview();
  });
  window.LDSGrilleHubShowcase = {mountAll: boot};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once:true}); else boot();
})();
